module.exports = __webpack_public_path__ + "img/icon-call-light-blue.55aebd21.svg";